export class FilterComplex {
  private field: string;
  private value: any;
  public operator?: OperatorEnum;

  constructor(fieldName: string, value: any, operator?: OperatorEnum) {
    this.field = fieldName;
    this.value = value;
    this.operator = operator;
  }

  public get filterEqualForStringValue(): string {
    return `${this.field} eq '${this.value}'`;
  }

  public get filterEqualForNumberValue(): string {
    return `${this.field} eq ${this.value}`;
  }

  public get filterContains(): string {
    return `contains(${this.field},'${this.value}')`;
  }

  public get filterStartWiths(): string {
    return `startswith(${this.field},'${this.value}')`;
  }
}

export enum OperatorEnum
{
  Equals = 0,
  Contains = 1,
  StartWiths = 2
}
